module.exports = __webpack_public_path__ + "static/media/82.020c9465.webp";